/**
 * 미디어 레이아웃 타입
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
 * 미디어 레이아웃 계산 훅
 * 
 * 미디어 표시 레이아웃, CSS 클래스 등 계산 로직을 제공합니다.
 */ export function useMediaLayout() {
    var displayMedia = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], normalVideos = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], shortFormVideos = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], isComplexMixedMedia = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, maxDisplay = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 4;
    // 숏폼 비디오 제한 - 너무 많으면 하나만 표시
    var optimizedDisplayMedia = _to_consumable_array(displayMedia);
    var displayedShortFormVideos = optimizedDisplayMedia.filter(function(media) {
        return shortFormVideos.includes(media);
    }).length;
    if (displayedShortFormVideos > 1 && !isComplexMixedMedia) {
        // 숏폼 비디오가 2개 이상이면 첫 번째 숏폼만 유지
        var firstShortForm = optimizedDisplayMedia.find(function(media) {
            return shortFormVideos.includes(media);
        });
        optimizedDisplayMedia = optimizedDisplayMedia.filter(function(media) {
            return !shortFormVideos.includes(media) || media === firstShortForm;
        });
        // 다른 미디어로 채우기
        var remainingMedia = displayMedia.filter(function(media) {
            return !optimizedDisplayMedia.includes(media) && !shortFormVideos.includes(media);
        });
        while(optimizedDisplayMedia.length < maxDisplay && remainingMedia.length > 0){
            optimizedDisplayMedia.push(remainingMedia.shift());
        }
    }
    // Complex Mixed Media 케이스 처리 - 일반 비디오, 숏폼 비디오, 이미지가 혼합된 경우
    if (isComplexMixedMedia) {
        // 미디어 타입별로 분류
        var normalVideoItems = optimizedDisplayMedia.filter(function(media) {
            return normalVideos.includes(media);
        });
        var shortFormVideoItems = optimizedDisplayMedia.filter(function(media) {
            return shortFormVideos.includes(media);
        });
        var imageItems = optimizedDisplayMedia.filter(function(media) {
            return !normalVideos.includes(media) && !shortFormVideos.includes(media);
        });
        // 일반 비디오가 있으면 첫 번째로 정렬하고 나머지는 2개만 표시
        if (normalVideoItems.length > 0) {
            var firstNormalVideo = normalVideoItems[0];
            // 나머지 항목을 추가 (숏폼 비디오 우선)
            var otherItems = _to_consumable_array(shortFormVideoItems).concat(_to_consumable_array(imageItems), _to_consumable_array(normalVideoItems.slice(1)));
            // 최대 3개 항목 (1개 일반 비디오 + 최대 2개 다른 항목)
            optimizedDisplayMedia = [
                firstNormalVideo
            ].concat(_to_consumable_array(otherItems.slice(0, 2)));
        } else if (shortFormVideoItems.length > 0) {
            // 숏폼 비디오 하나를 첫 번째로 배치, 나머지는 이미지 (최대 3개)
            var firstShortFormVideo = shortFormVideoItems[0];
            var remainingShortForms = shortFormVideoItems.slice(1);
            // 균형 있는 레이아웃을 위해 최대 3개로 제한
            optimizedDisplayMedia = [
                firstShortFormVideo
            ].concat(_to_consumable_array(imageItems.slice(0, 2 - Math.min(remainingShortForms.length, 1))), _to_consumable_array(remainingShortForms.slice(0, 1)));
        }
    }
    // 특별한 케이스: 3개의 미디어 항목이 있고 첫 번째가 일반 비디오인 경우
    var isThreeItemsWithNormalVideo = optimizedDisplayMedia.length === 3 && normalVideos.includes(optimizedDisplayMedia[0]);
    // 특별한 케이스: 4개의 미디어 항목이 있고 일반 비디오가 포함된 경우
    var hasFourItemsWithNormalVideo = optimizedDisplayMedia.length === 4 && optimizedDisplayMedia.some(function(media) {
        return normalVideos.includes(media);
    });
    // 4개 항목 중 일반 비디오가 있는 경우, 레이아웃 최적화
    if (hasFourItemsWithNormalVideo && !isComplexMixedMedia) {
        // 일반 비디오를 첫 번째로 이동
        var normalVideoItems1 = optimizedDisplayMedia.filter(function(media) {
            return normalVideos.includes(media);
        });
        var otherItems1 = optimizedDisplayMedia.filter(function(media) {
            return !normalVideos.includes(media);
        });
        // 일반 비디오가 여러 개인 경우 하나만 표시 (첫 번째 항목)
        if (normalVideoItems1.length > 1) {
            var firstNormalVideo1 = normalVideoItems1[0];
            optimizedDisplayMedia = [
                firstNormalVideo1
            ].concat(_to_consumable_array(otherItems1.slice(0, maxDisplay - 1)));
        } else {
            optimizedDisplayMedia = _to_consumable_array(normalVideoItems1).concat(_to_consumable_array(otherItems1.slice(0, maxDisplay - normalVideoItems1.length)));
        }
    }
    // 레이아웃 결정 
    var gridLayoutType;
    if (optimizedDisplayMedia.length === 1) {
        gridLayoutType = 'single';
    } else if (optimizedDisplayMedia.length === 2) {
        gridLayoutType = 'two-cols';
    } else if (optimizedDisplayMedia.length === 3) {
        if (isThreeItemsWithNormalVideo || isComplexMixedMedia && normalVideos.length > 0) {
            gridLayoutType = 'one-plus-two';
        } else {
            gridLayoutType = 'three-cols';
        }
    } else {
        if (hasFourItemsWithNormalVideo) {
            gridLayoutType = 'one-plus-three';
        } else {
            gridLayoutType = 'two-by-two';
        }
    }
    // 그리드 템플릿 클래스 결정
    var gridTemplateClass = '';
    switch(gridLayoutType){
        case 'single':
            gridTemplateClass = 'grid-cols-1';
            break;
        case 'two-cols':
            gridTemplateClass = 'grid-cols-2';
            break;
        case 'three-cols':
            gridTemplateClass = 'grid-cols-3';
            break;
        case 'one-plus-two':
            gridTemplateClass = 'grid-cols-1 md:grid-cols-2';
            break;
        case 'one-plus-three':
            gridTemplateClass = 'grid-cols-1 md:grid-cols-2';
            break;
        case 'two-by-two':
            gridTemplateClass = 'grid-cols-2';
            break;
        default:
            gridTemplateClass = 'grid-cols-2';
    }
    // 아이템 포지션 클래스 결정
    var getItemPositionClass = function(index, isNormalVideo, isFirstItem) {
        // 첫 번째 아이템이고 일반 비디오인 경우
        if (isFirstItem && isNormalVideo) {
            if (gridLayoutType === 'one-plus-two' || gridLayoutType === 'one-plus-three') {
                return 'col-span-full aspect-[16/9]';
            }
        }
        return 'aspect-square';
    };
    return {
        optimizedDisplayMedia: optimizedDisplayMedia,
        gridLayoutType: gridLayoutType,
        gridTemplateClass: gridTemplateClass,
        getItemPositionClass: getItemPositionClass
    };
}
export default useMediaLayout;
